// app/javascript/controllers/toast_controller.js
import { Controller } from "@hotwired/stimulus"
import Swal from "sweetalert2"

export default class extends Controller {
    connect() {
        // Register only once
        if (!window._contactAddedListener) {
            window._contactAddedListener = true
            window.addEventListener("contact:added", this.contactAdded)
        }
    }

    disconnect() {
        // Optional: keep listener if you want it globally
        // or remove if you want to free it
    }

    contactAdded() {
        Swal.fire({
            title: "Contact added",
            icon: "success",
            timer: 1200,
            showConfirmButton: false,
            customClass: {
                popup: "swal2-ea-popup",
                title: "swal2-ea-title"
            }
        })
    }
}